import type { DSIconSize } from "@/src/design_system/primitives/icon/types";
import type { DSThumbnailSize } from "@/src/design_system/data_display/thumbnail/types";

export const DS_THUMBNAIL_CLASSES = {
  Root: "ds-thumbnail",
  Surface: "ds-thumbnail__surface",
  Image: "ds-thumbnail__image",
  Icon: "ds-thumbnail__icon",
  Text: "ds-thumbnail__text",
  Loading: "ds-thumbnail__loading",
  Progress: "ds-thumbnail__progress",
  Overlay: "ds-thumbnail__overlay",
  Actions: "ds-thumbnail__actions",
  Description: "ds-thumbnail__description",
  FileName: "ds-thumbnail__file-name",
  FileNameBase: "ds-thumbnail__file-name-base",
  FileNameExtension: "ds-thumbnail__file-name-extension",
  Metadata: "ds-thumbnail__metadata",
  FileSize: "ds-thumbnail__file-size",
  FileDate: "ds-thumbnail__file-date",
  WithDescription: "ds-thumbnail--with-description",
} as const;

export const DS_THUMBNAIL_SIZE_TO_CLASS_MAP: Record<DSThumbnailSize, string> = {
  xs: "ds-thumbnail--xs",
  sm: "ds-thumbnail--sm",
  md: "ds-thumbnail--md",
  lg: "ds-thumbnail--lg",
  xl: "ds-thumbnail--xl",
};

export const DS_THUMBNAIL_SIZE_TO_CONTENT_ICON_SIZE_MAP: Record<DSThumbnailSize, DSIconSize> = {
  xs: "sm",
  sm: "lg",
  md: "xl",
  lg: "xl",
  xl: "xl",
};

export const DS_THUMBNAIL_SIZE_TO_OVERLAY_ICON_SIZE_MAP: Record<DSThumbnailSize, DSIconSize> = {
  xs: "md",
  sm: "lg",
  md: "xl",
  lg: "xl",
  xl: "xl",
};
